import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=784414ff&"
import script from "./Discipline.vue?vue&type=script&lang=js&"
export * from "./Discipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports